import type { MypageOtherTab, MypageTab, MypageTagTab } from '@coorum-research/shared-common/types/mypage-setting.type'
import { isOtherTab, isTagTab } from '@coorum-research/shared-common/types/mypage-setting.type'
import { Fragment, use } from 'react'
import { MyPageContext } from './MypageContext'
import { StatCardsRoot } from './StatCards'
import { Tabs } from './Tabs'
import { ThemeContext } from './ThemeContext'

type Props = {
  tabs: MypageTab[]
  headerTabMode: string
  renderStatsContent: (stat: MypageTagTab, index: number) => React.ReactNode
  renderTabContent: (tab: MypageTagTab) => React.ReactNode
  renderOtherTabContent: (args: {
    tab: MypageOtherTab
    tabs: MypageTab[]
  }) => React.ReactNode
  renderCalendar: () => React.ReactNode
}

export function MyPageAnswerList(props: Props) {
  const {
    tabs,
    headerTabMode,
    renderStatsContent,
    renderTabContent,
    renderOtherTabContent,
    renderCalendar,
  } = props

  const { tabValue, setTabValue } = use(MyPageContext)
  const currentTab = tabs.find(tab => tab.id === tabValue) ?? tabs[0]
  const tabsWithoutOther = tabs.filter(isTagTab)

  // Tabsが常にcontrolled stateになるよう、undefinedを防ぐ
  const tabsValue = currentTab?.id ?? tabs[0]?.id ?? ''

  const { mainTextColor } = use(ThemeContext)

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="mx-4 flex-[0_0_auto]" style={{ color: mainTextColor }}>
        {headerTabMode === 'home' && tabsWithoutOther.length > 0
          && (
            <StatCardsRoot>
              {tabsWithoutOther.map((item, index) => (
                <Fragment key={item.id}>
                  {renderStatsContent(item, index)}
                </Fragment>
              ))}
            </StatCardsRoot>
          )}
        {headerTabMode === 'calendar' && <>{renderCalendar()}</>}
      </div>
      <Tabs.Root value={tabsValue} onValueChange={setTabValue} className="bg-white shadow-none">
        {tabs.length > 1
          && (
            <Tabs.List className="flex-[0_0_auto] overflow-x-auto">
              {tabs.map(tab => (
                <Tabs.Trigger key={tab.id} value={tab.id ?? ''} className="shrink-0 flex-nowrap" isActive={currentTab?.id === tab.id}>{tab.label}</Tabs.Trigger>
              ))}
            </Tabs.List>
          )}
        <div className="flex-[1_1_auto] overflow-y-auto">
          {tabs.map(tab => (
            <Tabs.Content
              key={tab.id}
              value={tab.id ?? ''}
            >
              {isOtherTab(tab)
                ? renderOtherTabContent({ tab, tabs: tabsWithoutOther })
                : renderTabContent(tab)}
            </Tabs.Content>
          ))}
        </div>
      </Tabs.Root>
    </div>
  )
}
